import {
  getCookie,
  getLangFromSearch,
  LANG_PROP_NAME,
  type LangDto,
  parseLangCookieRaw,
} from '@skillarea/lib-shared';

export function getBrowserLocale(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return window.navigator.languages?.[0] ?? window.navigator.language;
}

export function getLangQueryParam(search?: string): string | undefined {
  const source =
    search ??
    (typeof window !== 'undefined' ? window.location.search : undefined);

  if (!source) {
    return undefined;
  }

  return getLangFromSearch(source);
}

export function parseLangCookieFromDocument(): LangDto {
  if (typeof document === 'undefined') {
    return {};
  }

  const raw = getCookie(LANG_PROP_NAME);
  if (!raw || typeof raw !== 'string') {
    return {};
  }

  return parseLangCookieRaw(raw) ?? {};
}
